import React from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './contact-us.css'

const ContactUs = (props) => {
  return (
    <div className="contact-us-container1">
      <Helmet>
        <title>Contact-Us - Sycorax Cats</title>
        <meta
          property="og:title"
          content="Contact-Us - Sycorax Cats"
        />
        <link
          rel="canonical"
          href="https://sycorax.uk/contact-us"
        />
        <meta
          property="og:url"
          content="https://sycorax.uk/contact-us"
        />
      </Helmet>
      <Navigation></Navigation>
      <section className="contact-form-section">
        <div className="contact-form-container">
          <div className="contact-form-card">
            <div className="contact-form-header">
              <div className="contact-form-icon-wrapper">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M12 5c.67 0 1.35.09 2 .26c1.78-2 5.03-2.84 6.42-2.26c1.4.58-.42 7-.42 7c.57 1.07 1 2.24 1 3.44C21 17.9 16.97 21 12 21s-9-3-9-7.56c0-1.25.5-2.4 1-3.44c0 0-1.89-6.42-.5-7s4.72.23 6.5 2.23A9 9 0 0 1 12 5m-4 9v.5m8-.5v.5"></path>
                    <path d="M11.25 16.25h1.5L12 17z"></path>
                  </g>
                </svg>
              </div>
              <h2 className="section-title">Contact Sycorax Cats</h2>
              <p className="section-content">
                Whether you&apos;re enquiring about available kittens, health
                testing, general breeding questions or anything else - drop us a
                message and we&apos;ll get back to you!
              </p>
            </div>
            <form
              action="https://formspree.io/f/mnpayajl"
              method="POST"
              data-form-id="8149e169-673e-47a3-93eb-a1617498304b"
              className="contact-us-thq-contact-form-grid-elm contact-form-grid"
            >
              <div className="contact-us-thq-contact-form-group-elm1 contact-form-group">
                <label htmlFor="name" className="contact-form-label">
                  <svg
                    width="18"
                    xmlns="http://www.w3.org/2000/svg"
                    height="18"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"></path>
                      <circle r="4" cx="12" cy="7"></circle>
                    </g>
                  </svg>
                  <span>Name</span>
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  required
                  minLength="2"
                  placeholder="Your name"
                  data-form-field-id="name"
                  className="contact-form-input"
                />
              </div>
              <div className="contact-us-thq-contact-form-group-elm2 contact-form-group">
                <label htmlFor="email-address" className="contact-form-label">
                  <svg
                    width="18"
                    xmlns="http://www.w3.org/2000/svg"
                    height="18"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="m22 7l-8.991 5.727a2 2 0 0 1-2.009 0L2 7"></path>
                      <rect x="2" y="4" rx="2" width="20" height="16"></rect>
                    </g>
                  </svg>
                  <span>Email Address</span>
                </label>
                <input
                  type="email"
                  id="email-address"
                  name="email"
                  required
                  placeholder="email@example.com"
                  data-form-field-id="email-address"
                  className="contact-form-input"
                />
              </div>
              <div className="contact-us-thq-contact-form-group-elm3 full-width contact-form-group">
                <label
                  htmlFor="message"
                  className="contact-us-thq-contact-form-label-elm3 contact-form-label"
                >
                  <svg
                    width="18"
                    xmlns="http://www.w3.org/2000/svg"
                    height="18"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>Your Message</span>
                </label>
                <textarea
                  id="message"
                  name="message"
                  required
                  minLength="10"
                  placeholder="Tell me about yourself and what you're looking for..."
                  data-form-field-id="message"
                  className="contact-form-textarea"
                ></textarea>
              </div>
              <div className="contact-us-thq-contact-form-footer-elm full-width contact-form-footer">
                <button
                  id="thq_button_nCD6"
                  name="button"
                  type="submit"
                  data-form-field-id="thq_button_nCD6"
                  className="btn-primary btn-lg btn contact-form-submit"
                >
                  <span>Send Inquiry</span>
                  <svg
                    width="20"
                    xmlns="http://www.w3.org/2000/svg"
                    height="20"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11zm7.318-19.539l-10.94 10.939"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                </button>
              </div>
            </form>
          </div>
        </div>
      </section>
      <div className="contact-us-container2">
        <div className="contact-us-container3">
          <Script
            html={`<script defer data-name="contact-form-handler">
(function(){
  const form = document.querySelector(".contact-form-grid")
  const submitBtn = document.querySelector(".contact-form-submit")

  if (form) {
    form.addEventListener("submit", (e) => {
      const originalText = submitBtn.innerHTML
      submitBtn.disabled = true
      submitBtn.innerHTML = "<span>Sending...</span>"

      // Simulate a short delay before native form submission proceeds
      // In a real environment, the native action would take over immediately
      setTimeout(() => {
        // Re-enable in case the user navigates back
        submitBtn.disabled = false
        submitBtn.innerHTML = originalText
      }, 2000)
    })

    // Visual feedback for validation
    const inputs = form.querySelectorAll(".contact-form-input, .contact-form-textarea")
    inputs.forEach((input) => {
      input.addEventListener("blur", () => {
        if (!input.checkValidity()) {
          input.style.borderColor = "#e74c3c"
        } else {
          input.style.borderColor = "var(--color-outline)"
        }
      })

      input.addEventListener("input", () => {
        if (input.checkValidity()) {
          input.style.borderColor = "var(--color-primary)"
        }
      })
    })
  }
})()
</script>`}
          ></Script>
        </div>
      </div>
      <Footer></Footer>
    </div>
  )
}

export default ContactUs
